import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const PolicyPrice = WithErrorBoundary(
  'Políticas de precios',
  'Error en Políticas de precios',
  React.lazy(() => import('./ListPolicyPrice.container'))
)

export default {
  path: '/politicas-de-precios',
  name: 'Políticas de precios',
  childRoutes: [
    {
      path: '',
      name: 'Políticas de precios',
      component: PolicyPrice,
      isIndex: true
    },
  ]
  
}
